module.exports = __webpack_public_path__ + "img/a312971.png";